import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import logoPng from 'assets/logos/pitstop-logo.png';
import failuresPng from 'v3/assets/failures.png';
import notifications from 'v3/assets/notifications.png';
import predictiveInsights from 'v3/assets/predictive_insights.png';
import routine from 'v3/assets/routine_service.png';
import { Slider } from 'v3/components/pitstop';

const Container = styled.div`
  height: 100%;
  width: 100%;
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  padding: 4vw 5vw 0vw 12vw;
  background: #02103d;
  border: 1px dashed #ffffff;
  box-sizing: border-box;

  h2 {
    color: #ffffff;
    font-size: 2rem;
    font-weight: 600;
    line-height: 2.375rem;
  }

  h3 {
    color: #4f75b9;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
  }

  p {
    color: #d9d9d9;
    line-height: 1.5rem;
    font-weight: 400;
  }

  li {
    font-size: 1rem;
    color: #d9d9d9;
  }
`;

const Img1 = styled.div`
  height: 48vh;
  margin: 5vh 0vh;
`;

const Logo = () => (
  <a
    href="https://pitstopconnect.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src={logoPng} alt="logo" height="70" />
  </a>
);

const FeatureImage = ({ src, alt }) => (
  <Img1>
    <img
      src={src}
      alt={alt}
      style={{
        maxWidth: '100%',
        maxHeight: '100%',
      }}
    />
  </Img1>
);

const slides = [
  {
    image: failuresPng,
    imageAlt: 'failures',
    title: 'Prioritize Vehicles and Potential Failures',
  },
  {
    image: notifications,
    imageAlt: 'notifications',
    title: 'Notifications',
  },
  {
    image: predictiveInsights,
    imageAlt: 'predictive_insights',
    title: 'Predictive Insights',
  },
  {
    image: routine,
    imageAlt: 'routine_service',
    title: 'Create usage based reminders for routine service alerts',
  },
];

const OnboardingSliderBackground = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setStep((prevStep) => (prevStep + 1) % 4);
    }, 5 * 3600);

    return () => clearInterval(intervalId);
  }, []);

  const currentSlide = slides[step];

  return (
    <Container>
      <Background style={{ height: '100%' }}>
        <>
          <Logo />
          <FeatureImage src={currentSlide.image} alt={currentSlide.imageAlt} />
          <h3>FEATURE</h3>
          <h2>{currentSlide.title}</h2>
        </>

        {slides.map((_, index) => (
          <Slider
            key={index}
            $isActive={step === index}
            onClick={() => setStep(index)}
          />
        ))}
      </Background>
    </Container>
  );
};

export default OnboardingSliderBackground;
